/**
 * Classify voucher firm as Rajput (sales) or Rajdoot (labor/vendor).
 *
 * Backend voucher list contract (VoucherController):
 * - Sales invoices → firm = exactly "Rajput Electricals"
 * - Labor / vendor invoices → firm = vendor first + last name
 *
 * Match the exact firm string only. Substring "rajput" would misclassify
 * vendors whose personal name contains that word.
 *
 * @param {string} firmName
 * @returns {'rajput'|'rajdoot'|'unknown'}
 */
const RAJPUT_FIRM = "rajput electricals";

export function classifyFirm(firmName = "") {
  const name = String(firmName || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");
  if (!name) return "unknown";
  if (name === RAJPUT_FIRM) return "rajput";
  return "rajdoot";
}

/**
 * Pick Rajput / Rajdoot invoice from a list of related SR invoices.
 * Unknown firms (empty firm) are assigned using preferredFirm, then fill
 * whichever side is empty — defaulting to Rajdoot (labor) first, since
 * vendor invoices are the common case when firm text is missing.
 */
export function splitServiceRequestInvoices(invoices = [], preferredFirm = "") {
  const list = (invoices || []).filter(
    inv => inv && inv.voucherType === "invoice"
  );

  let rajputInvoice =
    list.find(inv => classifyFirm(inv.firm) === "rajput") || null;
  let rajdootInvoice =
    list.find(inv => classifyFirm(inv.firm) === "rajdoot") || null;

  const unknowns = list.filter(inv => classifyFirm(inv.firm) === "unknown");
  const preferred = classifyFirm(preferredFirm);

  unknowns.forEach(inv => {
    if (preferred === "rajput") {
      if (!rajputInvoice) rajputInvoice = inv;
      else if (!rajdootInvoice) rajdootInvoice = inv;
    } else {
      // prefer rajdoot / default (vendor labor bills)
      if (!rajdootInvoice) rajdootInvoice = inv;
      else if (!rajputInvoice) rajputInvoice = inv;
    }
  });

  return { rajputInvoice, rajdootInvoice };
}

export function isInvoicePaid(invoice) {
  if (!invoice) return false;
  return (parseFloat(invoice.balance) || 0) <= 0;
}
